import PosControle from "@/modules/PosControle/pages/Index";

export default [
  {
    name: "posControle",
    path: "/pos/controle",
    component: PosControle,
    meta: { title: "Integração POS Controle" },
  },
];
